import { render } from "./DashboardLayout.vue?vue&type=template&id=89d3e25e&ts=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=89d3e25e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__